import React from 'react'
import cn from 'classnames'

function Card({ className, children }) {
  return (
    <div className={cn('card p-3 rounded-3 border-0', className)} style={{ backgroundColor: '#1a1d21', border: '1px solid rgba(255, 255, 255, 0.04)' }}>
      {children}
    </div>
  )
}

export default Card
